<template>
  <div class="home-page-wrapper about-page-wrapper">
    <HeroBanner
      :title="privacyPolicy.title"
      :image-url="generateImageUrl(privacyPolicy.image)"
      image-url-present
    />
    <Social />
    <Message
      class="privacy-message-wrapper"
      :title="privacyPolicy.subTitle"
      :description="privacyPolicy.description"
    />
  </div>
</template>

<script>
import HeroBanner from "@/pageComponents/globalUi/hero-banner";
import Message from "@/pageComponents/about/message";
import Social from '@/pageComponents/social/Social'
import { mapGetters } from "vuex";

const MISC_STORE_KEY = "miscStore";

export default {
  name: "About",
  components: {
    HeroBanner,
    Message,
    Social
  },

  computed: {
    ...mapGetters({
      privacyPolicy: `${MISC_STORE_KEY}/privacyPolicy`
    })
  },

  async mounted() {
    await this.$store.dispatch(`${MISC_STORE_KEY}/getPrivacyPolicy`);
  }
};
</script>

<style lang="scss">
.privacy-message-wrapper {
  .description {
    /deep/ p {
      text-align: unset !important;
    }
  }
}
</style>
